import {
  TextWithImageBlockProps,
  TextWithImageBlockImagePosition,
  UseServer,
  ButtonProps,
  ImageWithAttribution,
} from '@stadionhq-v3/base-ui';
import { DocumentLinks, Theme } from '@stadionhq-v3/core';
import { TextWithImageBlock } from '@graphql/__generated__/graphql';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import ContentfulRichTextRenderer from '@components/helpers/contentful-rich-text-render';
import { isLink } from '@core/types/typeGuards';
import { Locale } from '@core/constants/locales.constants';
import { renameKeyFromTitleToText } from '@utils/objects.utils';
import { linkTransform } from '../atoms';

const textWithImageBlockTransform = (
  {
    title,
    subTitle,
    introParagraph,
    theme,
    label,
    content,
    imagePosition,
    image,
    links,
  }: CleanContentful<TextWithImageBlock>,
  locale: Locale
): TextWithImageBlockProps => ({
  title,
  subTitle,
  theme: (theme as Theme) || undefined,
  showTitle: true,
  label,
  introParagraph,
  bodyCopy: (
    <UseServer>
      <ContentfulRichTextRenderer
        document={{
          json: content?.json,
          links: content?.links as DocumentLinks,
        }}
        theme={(theme as Theme) || undefined}
        compact
      />
    </UseServer>
  ),
  imagePosition: imagePosition as TextWithImageBlockImagePosition,
  image: image && (
    <ImageWithAttribution image={<ContentfulImage {...image} />} {...image} />
  ),
  links: links
    ?.filter(isLink)
    ?.map((link) =>
      renameKeyFromTitleToText(linkTransform(link, locale))
    ) as ButtonProps[],
});

export default textWithImageBlockTransform;
